<template>
  <div class="index">
    <van-nav-bar
        title="绑定用户"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />
    <div style="margin: 16px;"/>
    <van-cell title="户号" v-model="c_code" />
    <van-cell title="户名" v-model="c_name" />
    <van-cell title="地址" v-model="c_address" />
    <van-cell title="电话" v-model="c_phone" />
    <div style="margin: 16px;">
      <van-button round block type="info" @click="wxbind">绑  定</van-button>
    </div>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import API from './../api/index'
export default {
  name: 'page_bind',
  data() {
    return {
      c_id: '',
      c_name: '',
      c_address: '',
      c_phone: '',
      c_code: '',
    };
  },
  methods: {
    setMessage() {
      this.c_id = this.$cookie.get('CID');
      this.c_code = this.$cookie.get('c_code');
      this.c_name = this.$cookie.get('c_name');
      this.c_address = this.$cookie.get('myAddress');
      this.c_phone = this.$cookie.get('myPhone');
    },
    wxbind() {
      Dialog.confirm({
        title: '提示',
        message: '是否绑定燃气用户？',
      })
          .then(() => {
            // on confirm
            this.$http.get(API.WeiXinBind,{
              params: {
                c_id:this.c_id
              }
            })
                .then((response)=>{
                  let res = response.data;
                  if (res.code === 0) {
                    this.$cookie.set('CID',this.c_id,  { expires: '360m' });
                    this.$cookie.set('CName',this.c_name,  { expires: '360m' });
                    this.$cookie.set('CAddress',this.c_address,  { expires: '360m' });
                    this.$cookie.set('C_Code',this.c_code,  { expires: '360m' });
                    this.$router.push('/index');
                  }
                })
          })
          .catch(() => {
            // on cancel
          });
    },
    onClickLeft(){
      this.$router.go(-1);
    }

  },
  mounted () {
    this.setMessage();
  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
</style>